// extracted by mini-css-extract-plugin
export default {"close_btn":"CloseBtn_close_btn__dGsKV","line":"CloseBtn_line__Abgp3","line_1":"CloseBtn_line_1__4z5Xg","line_2":"CloseBtn_line_2__LYkV3"};